import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const Checklist: React.FC = () => {
  const items = ['Acceso completo a la guía principal', 'Estrategias emocionales paso a paso', 'Técnicas para dejar de sobrepensar', 'Cómo cambiar la dinámica sin perseguir', 'Cómo recuperar misterio y valor emocional', 'Acceso desde cualquier dispositivo', 'Actualizaciones futuras GRATIS', 'Bonus #1: Mensajes emocionales ($37.900)', 'Bonus #2: Cómo dejar de sobrepensar cuando él se aleja ($47.900)', 'Bonus #3: Energía femenina inolvidable ($27.900)', 'Bonus #4: Reconstrucción emocional ($39.900)'];
  return <section className="py-16 px-4 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-center mb-10 text-brand-charcoal" data-id="element-49">
          Aquí Está Todo Lo Que Obtienes:
        </h3>

        <div className="bg-brand-cream p-8 md:p-12 rounded-3xl shadow-sm border border-brand-blush" data-id="element-50">
          <ul className="space-y-4" data-id="element-51">
            {items.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-start gap-3 text-lg text-gray-800" data-id="element-52">
                <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0 mt-0.5" data-id="element-53" />
                <span className={item.includes('Bonus') ? 'font-medium' : ''} data-id="element-54">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
};